import { QueryClient } from '@tanstack/react-query';
import { db } from '@/integrations/neon/db';
import { toast } from 'sonner';

export async function fetchActiveProgramCredits(userId: string): Promise<number> {
  const { data, error } = await db
    .from('user_program_credits_balance')
    .select('active_program_credits')
    .eq('user_id', userId)
    .maybeSingle();

  if (error && error.code !== 'PGRST116') {
    console.warn('fetchActiveProgramCredits:', error.message);
  }
  return data?.active_program_credits ?? 0;
}

export function invalidateProgramCreditQueries(queryClient: QueryClient, userId: string | undefined) {
  if (!userId) return;
  queryClient.invalidateQueries({ queryKey: ['program-credits', userId] });
  queryClient.invalidateQueries({ queryKey: ['tier-credits', userId] });
  queryClient.invalidateQueries({ queryKey: ['credits', userId] });
  queryClient.invalidateQueries({ queryKey: ['credits-used', userId] });
}

/** Returns false if user cannot afford `amount` (and shows toast). */
export async function ensureProgramCredits(
  userId: string,
  amount: number,
  label: string,
): Promise<boolean> {
  const balance = await fetchActiveProgramCredits(userId);
  if (balance < amount) {
    toast.error(
      `Insufficient program credits for ${label}. Need ${amount}, you have ${balance}. Add credits from your subscription page.`,
    );
    return false;
  }
  return true;
}
